<template>
  <div class="mx-auto w-100" style="max-width: 1080px">
    <div v-if="isLoadingPractices">
      <div class="row mt-5">
        <div class="col mx-auto">
          <placeholders-text :lines="1" class="fixed" height="8rem" />
        </div>
      </div>
    </div>
    <div
      v-else
      class="w-100 referral-container bg-white mx-auto p-5 px-6 paper-shadow mt-5"
      style="margin-bottom: 100px"
    >
      <h2>Which practice would you like to send to?</h2>
      <practice-auto-complete
        v-if="practices.length > 1"
        v-model="to_practice_id"
        :isSearchable="false"
        @selected="(p) => $router.push(`/send/${p.id}/`)"
        :closeOnSelect="true"
        :items="practices"
        style="font-size: 1rem"
        :placeholder="'Select practice'"
      />
      <div
        v-else
        class="d-flex mb-3"
        v-for="practice in practices"
        :key="practice.id"
        style="cursor: pointer; max-width: 550px"
        @click.prevent="$router.push(`/send/${practice.id}/`)"
      >
        <!-- <div class="align-items-center d-flex p-3"><input type="radio" class="p-3" /></div> -->
        <practice-list-item :item="practice" class="w-100"> </practice-list-item>
      </div>
    </div>
  </div>
</template>

<script>
import PracticeAutoComplete from '../../components/add-practice/PracticeAutoComplete.vue'
import PracticeListItem from '../../components/add-practice/PracticeListItem.vue'
import { PracticeApi } from '../../services'
export default {
  components: {
    PracticeListItem,
    PracticeAutoComplete,
  },
  data() {
    return {
      practices: [],
      isLoadingPractices: false,
      to_practice_id: null,
    }
  },
  async created() {
    if (this.toPracticeSlugOrId?.length > 1) {
      this.isLoadingPractices = true
      try {
        this.practices = await PracticeApi.get('?ids=' + this.toPracticeSlugOrId.join(','), '', { anonymous: true })
        if (this.practices.length === 1) this.$route.push(`/send/${this.practices[0].id}`)
      } catch (e) {
        this.$exception(e)
        this.$helpers.error('Failed to load all offices. Check the link and try again.')

        //todo: redirect
      }

      this.isLoadingPractices = false
    }
  },
  computed: {
    toPracticeSlugOrId() {
      if (this.$route.params.to && this.$route.params.to !== '0') {
        return this.$route.params.to.split(',')
      }

      return undefined
    },
  },
}
</script>

<style>
</style>